import ReactTooltip from 'react-tooltip';

const Tooltip = ({ id, size }) => {
  return (
    <ReactTooltip
      id={id}
      className={`spo-a-tooltip ${size ? `spo-a-tooltip--${size}` : ''}`}
      backgroundColor="#0057b7"
    />
  );
};

export default Tooltip;
